// Public api
const apiUrl = 'https://task-maestro-backend-production.up.railway.app/api/tasks/';

// Private api
// const apiUrl = "http://135.0.137.131:8000/api/tasks/";

// test api ip
// const apiUrl = "http://135.0.15.94:8000/api/tasks/";

// Private api dns
// const apiUrl = "http://ip-135-0-137-131.us-east-2.compute.internal:8000/api/tasks/";

// Localhost
// const apiUrl = 'http://127.0.0.1:8000/api/tasks/';

export default apiUrl;
